i<template>
  <div style="background: #fff;position: relative">
    <page-tab :tabs="tabs" :nowTab="nowTab"></page-tab>
    <div class="addAccount" @click="toAddAccount()">
      <i class="yjh-icon icon-add-account"></i>
      <span>新增{{pageType === 'account' ? '账号' : '权限组'}}</span>
    </div>
    <page-table
      ref="table"
      :loading="tableLoading"
      :col="tableCol"
      :data="tableData"
      :showPage="false"
      @compFn="compFn"
    ></page-table>
    <simple-diag
      :isShow="delDiag"
      :title="delTitle"
      :width="'400px'"
      :htm="false"
      @confirm="confirm"
      @close="toggleDelDiag(false)">
      <template>
        <div class="simple-diag-text">
          确定要删除{{pageType === 'account' ? '账号' : '权限组'}} <span class="blue">{{delName}}</span> 吗？删除后不可恢复
        </div>
      </template>
    </simple-diag>
  </div>
</template>
<script>
import pageTab from '../../components/pageCom/pageTab'
import pageTable from '../../components/pageCom/pageTable'
import pageTableMixin from '../../components/pageCom/pageTableMixin.js'
import simpleDiag from '@/components/dialogs/simpleDiag'
import { getAccountList, getDelAccount, getJurisdictionList, getDelJurisdiction } from '@/api/app'
import accountOperate from './accountOperate'
import Vue from 'vue'
Vue.component('accountOperate', accountOperate)
export default {
  name: 'account-permission',
  components: { pageTab, pageTable, simpleDiag },
  mixins: [pageTableMixin],
  data() {
    return {
      tabs: [{
        text: '账号列表',
        linkName: 'accountList'
      }, {
        text: '权限组',
        linkName: 'jurisdictionSet'
      }],
      tableLoading: false, // 表格loading
      tableDataCount: 0, // 表格总数据
      tableCol: [], // 表格头数据
      tableData: [], // 表格数据
      delDiag: false, // 删除弹框
      delTitle: '删除提示',
      delName: '',
      adminId: '', // 管理员编号
      pageType: '' // account账号  permission权限
    }
  },
  computed: {
    nowTab() {
      return this.$route.name
    }
  },
  methods: {
    initPage() {
      this.$store.dispatch('setPage', { title: '账号权限', type: 'cover' })
      if (this.$route.name === 'accountList') {
        this.pageType = 'account'
        this.tableCol = [{
          field: 'custome-adv', title: '操作', width: 100, titleAlign: 'left', columnAlign: 'left', componentName: 'accountOperate', isResize: true
        }, {
          field: 'admin_name', title: '登录名', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData, rowIndex, pagingIndex, field) {
            return rowData[field] === null ? '——' : rowData[field]
          }
        }, {
          field: 'gname', title: '权限组', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true
        }, {
          field: 'admin_login_time', title: '上次登录时间', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData, rowIndex, pagingIndex, field) {
            return rowData[field] === '0' ? '——' : rowData[field]
          }
        }, {
          field: 'admin_login_num', title: '登录次数', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true
        }]
      } else if (this.$route.name === 'jurisdictionSet') {
        this.pageType = 'permission'
        this.tableCol = [{
          field: 'custome-adv', title: '操作', width: 100, titleAlign: 'left', columnAlign: 'left', componentName: 'jurisdiction-operation', isResize: true
        }, {
          field: 'gname', title: '权限组', width: 260, titleAlign: 'left', columnAlign: 'left', isResize: true
        }]
      }
    },
    // 删除账号确认
    confirm() {
      if (this.pageType === 'account') {
        getDelAccount({ admin_id: this.adminId }).then(res => {
          this.handleDelete(res)
        })
      } else {
        getDelJurisdiction({ gid: this.adminId }).then(res => {
          this.handleDelete(res)
        })
      }
    },
    handleDelete(res) {
      if (res.code === 0) {
        this.toggleDelDiag(false)
        this.getData()
      } else if (res.code !== 10008) {
        this.$Message.info(res.msg)
      }
    },
    // 删除弹框
    toggleDelDiag(flag) {
      this.delDiag = flag
    },
    // 表格内操作
    compFn(params) {
      this.delName = this.pageType === 'account' ? this.tableData[params.index].admin_name : this.tableData[params.index].gname
      this.adminId = this.pageType === 'account' ? this.tableData[params.index].admin_id : this.tableData[params.index].gid
      this.toggleDelDiag(true)
    },
    // 获取表格数据
    getData() {
      const obj = { 'account': getAccountList, 'permission': getJurisdictionList }
      this.tableLoading = true
      obj[this.pageType]({ page: '1', per_page: '100' }).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result.data
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.tableData = []
        }
      })
    },
    // 去新增页面
    toAddAccount() {
      // 如果进入了 新增 就本地存储一个值
      localStorage.setItem('isNull', 'true')
      localStorage.setItem('routeName', this.$route.name)
      this.$router.push({ name: this.pageType === 'account' ? 'addAccount' : 'addJurisdiction' })
    }
  }
}
// 自定义列组件
Vue.component('jurisdiction-operation', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    // 编辑
    updateJurisdiction() {
      // 如果进入了 编辑 就本地存储一个值
      localStorage.setItem('isNull', 'true')
      localStorage.setItem('routeName', this.$route.name)
      this.$router.push({
        name: 'editJurisdiction',
        query: {
          name: this.rowData['gname'],
          id: this.rowData['gid']
        }
      })
    },
    // 删除
    deleteRowJurisdiction() {
      this.$emit('on-custom-comp', { index: this.index })
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.deleteRowJurisdiction
      }
    }, '删除'), h('a', {
      on: {
        click: this.updateJurisdiction
      }
    }, '编辑')])
  }
})
</script>
<style lang="scss">
  .addAccount {
    color: #5D6F80;
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 0;
    span {
      display: inline-block;
      height: 18px;
      line-height: 18px;
    }
  }
  .operate{
    a:first-child {
      margin-right: 20px;
    }
  }
</style>
